module.exports = __webpack_public_path__ + "nachschlagewerk.png?a28179c108e8d53bd141413672ccea3b";


//////////////////
// WEBPACK FOOTER
// ./lib/assets/nachschlagewerk.png
// module id = 14
// module chunks = 0